<template>
  <div class="re_detail">
    <a-drawer
      :title="modalInfoTit"
      placement="right"
      wrap-class-name="incept_drawer"
      :visible="visible"
      :mask-closable="false"
      width="800"
      @close="onClose"
    >
      <div
        v-if="!reason.show"
        class="detail_overview"
        :class="{'en-detail-overview': isEnglish}"
      >
        <p>
          <span class="ovierview_title">{{ $t('message["582"]') }}：</span>
          {{ listDetail.from_url }}
        </p>
        <p>
          <span class="ovierview_title">{{ $t('message["580"]') }}IP：</span>
          {{ listDetail.from_ip }}
          <span
            v-if="detailData.from_ip_city"
            class="ip-city"
          >[{{ detailData.from_ip_city }}]</span>
        </p>
        <p>
          <span class="ovierview_title">{{ $t('message["1170"]') }}：</span>
          {{ formatDate(detailData.input_time) }}
        </p>
        <p>
          <span class="ovierview_title">{{ $t('message["1973"]') }}：</span>
          {{ detailData.from_agent }}
        </p>
      </div>
      <div
        v-if="!!detailData.is_show_oplog && detailData.op_truename"
        class="deal-record-box"
      >
        <i class="iconfont iconicon-test68" />
        <h2>{{ $t('message["119"]') }}</h2>
        <p>{{ formatDate(detailData.op_time) }} {{ detailData.op_truename }} <span v-if="detailData.op_rolename">[{{ detailData.op_rolename }}]</span></p>
        <p>{{ detailData.op_reason || '' }}</p>
      </div>
      <a-form
        :form="form"
        class="detail_main"
      >
        <div
          v-if="reason.show"
          class="intercept_reson"
        >
          <div class="reason_main">
            <i class="iconfont iconicon-test68" />
            <div class="text_main">
              <p>{{ $t('message["339"]') }}</p>
              <p
                class="intercept_content"
                v-text="reason.text"
              />
            </div>
          </div>
        </div>
        <div
          v-for="item in formDetail"
          :key="item.key"
          class="detail_item"
        >
          <template v-if="['text'].includes(item.fieldtype)">
            <detail-item
              class="smart_smart-detail_item clearfix"
              :data="item"
            />
          </template>
          <template v-else-if="['file'].includes(item.fieldtype)">
            <div class="file_main">
              <file-list
                class="smart_smart-detail_item clearfix"
                :data="item"
              />
              <a-button
                v-if="showSetField(item)"
                class="set_fields"
                @click="toSetFields"
              >
                {{ $t('message["1020"]') }}
              </a-button>
            </div>
          </template>
          <template v-else-if="['editor'].includes(item.fieldtype)">
            <p
              class="detail_field"
            >
              {{ isMatchSetField(item) ? item.fieldname : `[${item.fieldkey}]` }}：
            </p>
            <div
              class="detail_value editor_content"
              v-html="$xss(item.fieldvalue, $xssOptions)"
            />
            <a-button
              v-if="showSetField(item)"
              class="set_fields"
              @click="toSetFields"
            >
              {{ $t('message["1020"]') }}
            </a-button>
          </template>
          <template v-else-if="['','radio', 'checkbox','select_tree','select'].includes(item.fieldtype)">
            <p
              class="detail_field"
            >
              {{ isMatchSetField(item) ? item.fieldname : `[${item.fieldkey}]` }}：
            </p>
            <div
              class="detail_value"
              v-html="$xss(formatFieldValue(item.fieldvalue), $xssOptions)"
            />
            <a-button
              v-if="showSetField(item)"
              class="set_fields"
              @click="toSetFields"
            >
              {{ $t('message["1020"]') }}
            </a-button>
          </template>
          <template v-else>
            <p
              class="detail_field"
            >
              {{ isMatchSetField(item) ? item.fieldname : `[${item.fieldkey}]` }}：
            </p>
            <div
              class="detail_value"
            >
              {{ item.fieldtype === 'area' ? formatFieldValue(item.fieldvalue, '/') : formatFieldValue(item.fieldvalue) }}
              <a-button
                v-if="showSetField(item)"
                class="set_fields"
                @click="toSetFields"
              >
                {{ $t('message["1020"]') }}
              </a-button>
            </div>
          </template>
        </div>
        <!-- 操作入口会有权限控制显示与否 -->
        <div
          class="footer"
        >
          <div
            v-if="[-2,-3].includes(recordStatus)"
            class="perpare_create_btns"
          >
            <a-button
              type="primary"
              @click="handleCancel"
            >
              {{ $t('message["899"]') }}
            </a-button>
            <a-button
              class="del"
              @click="handleDelete"
            >
              {{ $t('message["962"]') }}
            </a-button>
          </div>
          <div
            v-else
            class="perpare_create_btns"
          >
            <a-button
              v-if="isInqueryAdd && (recordStatus === -1 || recordStatus === 3)"
              type="primary"
              @click="toEntry"
            >
              {{ $t('message["617"]') }}
            </a-button>
            <a-button
              v-if=" recordStatus === -1"
              class="r_btn"
              @click="handleDeal"
            >
              {{ $t('message["65"]') }}
            </a-button>
            <!-- new -->
            <a-button
              class="del"
              @click="handleDelete"
            >
              {{ $t('message["962"]') }}
            </a-button>
          </div>
        </div>
      </a-form>
    </a-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapActions } from 'vuex'
import detailItem from '@/pc/inquery/formItem/Item'
import fileList from './File'
import { isObject, formatDate } from '../common'
import { getLang } from '@/lib/storage'

const HIDDEN_STATUS = [0, 1, 2]

export default {
  components: {
    detailItem,
    fileList
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    init: {
      type: Function,
      default () {
      }
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      reason: {}
    }
  },
  computed: {
    ...mapState('smart/submit', ['listDetail', 'isInqueryAdd', 'detailData']),
    formDetail () {
      let arr = []
      const { data, reason } = this.listDetail
      if (reason && reason.length > 0) {
        this.$set(this._data, 'reason', { show: true, text: reason.join('；') })
      } else {
        this.$set(this._data, 'reason', { show: false })
      }
      for (let key in data) {
        let item = data[key]
        if (item['fieldtype'] === 'text') {
          item['fieldtype'] = 'area'
        }
        if (item['fieldauth'] && item['fieldauth'] * 1 === 1) {
          item['fieldvalue'] = '***'
        }
        arr.push({ fieldkey: key, ...item })
      }
      return arr
    },
    hiddenFooter () {
      return HIDDEN_STATUS.includes(this.recordStatus)
    },
    recordStatus () {
      const { status } = this.listDetail
      return status
    },
    formid () {
      const { formid } = this.listDetail
      return formid
    },
    formType () {
      const { formtype } = this.listDetail
      return formtype
    },
    modalInfoTit () {
      return this.$t('message["89"]')
    },
    delTips () {
      return this.$t('message["967"]').split('|')
    },
    delTit () {
      return this.$t('message["973"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  methods: {
    formatDate,
    getLang,
    ...mapActions('smart/submit', ['delRecords']),
    onClose () {
      this.$emit('update:visible', false)
    },
    formatFieldValue (value, sep = ',') {
      console.log(value)
      let str = ''
      if (Array.isArray(value)) {
        str = value.join(sep)
      } else if (isObject(value)) {
        let arr = []
        if ('address' in value || 'code' in value) {
          // 地区地址
          const { code, address } = value
          for (let key in code) {
            arr.push(code[key])
          }
          if (address) {
            arr.push(address)
          }
        } else if ('treedata' in value) {
          // 树形表单
          const { treedata } = value
          for (let key in treedata) {
            arr.push(treedata[key])
          }
        } else {
          for (let key in value) {
            arr.push(value[key])
          }
        }
        str = arr.join(sep)
      } else {
        str = value
      }
      return str
    },
    // 取消拦截
    handleCancel () {
      this.$emit('cancel', { formid: this.id })
      this.onClose()
    },
    toEntry () {
      this.$emit('entry', { form_history_id: this.id })
    },
    // 不录入操作｜先弹框输入不录入的原因，再点击确定
    handleDeal () {
      this.$emit('deal', { id: this.id })
      // this.onClose()
    },
    // 删除操作
    handleDelete () {
      const that = this
      this.$confirm({
        iconType: 'info-circle',
        title: [-2, -3].includes(this.recordStatus) ? this.delTit[0] : this.delTit[1],
        content: <div>{this.delTips[0]}<span class="confitm_warning">{this.delTips[1]}</span>{this.delTips[2]}</div>,
        okText: this.$t('message["915"]'),
        cancelText: this.$t('message["896"]'),
        closable: true,
        onOk: () => {
          that.delRec()
        }
      })
    },
    async delRec () {
      const chain = await this.delRecords({ ids: [this.id] })
      // console.log(this.selectedRowKeys)
      chain.onSuccess(raw => {
        this.$message.success(this.$t('message["965"]') + '！')
        this.onClose()
        this.init()
      })
        .fetch()
    },
    // 设置对应字段-跳转到外部表单的编辑里
    toSetFields () {
      let query = Object.assign({}, { tab: 2 }, { type: 2 }, { formid: this.formid })
      this.$router.push({ name: 'UniversalOutsideForm', query })
    },
    // 是否显示【设置对于字段】按钮
    showSetField (item) {
      const { tab } = this.$route.query
      const { ismatch } = item
      return tab === 'subRecord' && this.formType === 2 && ismatch === 0
    },
    isMatchSetField (item) {
      const { ismatch, fieldkey, fieldname } = item
      if (ismatch === 1) {
        return true
      } else {
        if (fieldname !== fieldkey) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.detail_overview {
  width: 100%;
  background: #F5F6F7;
  padding: 12px 54px;
  border-radius: 4px;
  p {
    color: #333;
    line-height: 24px;
    .ovierview_title {
      display: inline-block;
      width: 80px;
      font-weight: 600;
      text-align: right;
      margin-right: 10px;
    }
    .ip-city {
      color: #b3b3b3;
      margin-left: 10px;
    }
  }
}
.en-detail-overview {
  .ovierview_title {
     width: 160px !important;
  }
}
.detail_main {
  margin-bottom: 50px;
  margin-top: 40px;
  .file_main {
    display: flex;
    flex-direction: row
  }
  .intercept_reson {
    position: relative;
    min-height: 64px;
    background: #fff4e7;
    border: 1px solid #f6a953;
    border-radius: 4px;
    margin: 0 0 16px 0;
    .reason_main {
      position: relative;
      margin: 12px 16px;
      .iconfont {
        position: absolute;
        top: 0;
        font-size: 16px;
        color: #f6a953;
      }
      .text_main {
        display: inline-block;
        margin-left: 32px;
        p {
          line-height: 24px;
        }
      }
    }
  }
  .detail_item {
    position: relative;
    width: 720px;
    min-height: 56px;
    margin: 0 auto;
    .detail_field, .detail_value {
      display: inline-block;
      margin: 4px 0;
    }
    .detail_field {
      min-width: 124px;
      vertical-align: top;
      color: #666;
      line-height: 24px;
      text-align: right;
    }
    .detail_value {
      max-width: 480px;
      line-height: 24px;
      margin-left: 16px;
      margin-right: 16px;
    }
    .editor_content {
      max-height: 160px;
      overflow: auto;
      border: 1px solid #d6d6d6;
      padding: 0 4px;
      border-radius: 4px;
    }
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 783px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: 1px solid $gray4;
    .perpare_create_btns {
      .r_btn {
        border-color: $danger-color;
      }
      .r_btn {
        color: $danger-color;
        background: #fff;
        margin-right: 8px;
      }
      .del {
        background: $danger-color;
        color: #fff;
        margin-left: 8px;
      }
    }
  }
}
.confitm_warning {
  color: #f57676;
}
.deal-record-box {
  position: relative;
  background: #fff4e7;
  border: 1px solid #f6a953;
  border-radius: 4px;
  margin-top: 16px;
  padding: 9px 9px 9px 48px;
  i {
    color: #f6a953;
    font-size: 16px;
    position: absolute;
    left: 17px;
    top: 9px;
  }
  h2{
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 8px;
  }
  p {
    line-height: 24px;
    span {
      color: #b3b3b3;
    }
  }
}
</style>
<style lang="scss">
.incept_drawer {
  .ant-drawer-header {
    border-bottom: 0;
  }
  .ant-drawer-title {
    font-size: 32px;
    margin-top: 32px;
  }
  .ant-drawer-close {
    top: 44px;
  }
  .anticon-close {
    margin-right: 40px;
    font-size: 32px;
  }
}
</style>
